// import { Route } from 'lucide-react';
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import FormShow from '../Components/ContactForm/FormShow';
import Homepage from '../Homepage/Homepage';
import ContactForm from '../Components/ContactForm/ContactForm';

const MainRoutes = () => {
  return (
    <Routes>
      <Route path='/form' element={<FormShow />} />
      <Route path='/' element={<Homepage />} />
    </Routes>
  );
};

export default MainRoutes;
